export enum TimeItemTypeEnum {
    ASSIGNMENT = 'ASSIGNMENT',
    CHECK_IN = 'CHECK_IN',
    CHECK_OUT = 'CHECK_OUT',
    COURT = 'COURT',
    END_TIME = 'END_TIME',
    ENVIRONMENTAL = 'ENVIRONMENTAL',
    MEDICAL = 'MEDICAL',
    OFFICIAL = 'OFFICIAL',
    PAYMENT = 'PAYMENT',
    PENALTY = 'PENALTY',
    RANKING = 'RANKING',
    RATING = 'RATING',
    RESUME_TIME = 'RESUME_TIME',
    SCHEDULED_DATE = 'SCHEDULED_DATE',
    SCHEDULED_TIME = 'SCHEDULED_TIME',
    START_TIME = 'START_TIME',
    STOP_TIME = 'STOP_TIME',
    SUSPENSION = 'SUSPENSION',
    VENUE = 'VENUE',
    INFRINGEMENT = 'INFRINGEMENT'
}
